import { createApp } from "vue";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";

import App from "./App.vue";
import router from "./router";
import Pagination from "@/components/common/Pagination.vue";
import "./assets/styles/_global.scss";

const app = createApp(App);
const pinia = createPinia();

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 注册全局公共组件
app.component("Pagination", Pagination);

app.use(pinia);
app.use(router);
app.use(ElementPlus, { locale: zhCn });

app.mount("#app");
